import { Url } from '../shared/Url';
import Post from '../shared/Post';

import { consultaUser } from './PefilFunction';

export const consultaEst = (respuesta) => {
    consultaUser ((usuario) => {
        let Content = {
            id: usuario
        }

        Post(`${Url}consultESt`, Content, (resp) => {
            let data = JSON.parse(resp);
            let datos = data[0];
            let statusVar = data[1];
            let datHistoricos = data[2];
            let carrera = data[3];
            let carreras = data[4];
            let carrCambio = data[5];
            let prederencias = data[6];
            let state1 = {
                icon: "fa fa-spinner fa-spin",
                text: "Verificando, espera por favor",
                class: "custom-alert-info",
                styles:{fontSize:12, position:"absolute", top: 4}
            }
            switch (statusVar) {
                case 1:
                    state1 = {
                        icon: "fa fa-times-circle",
                        text: "Para poder solicitar el cambio de carrera no debes estar inscrito",
                        class: "custom-alert-danger",
                        styles:{fontSize:12, position:"absolute", top: 4}
                    };
                    break;
                case 2:
                    state1 = {
                        icon: "fa fa-check-circle",
                        text: "Puedes realizar el cambio de carrera",
                        class: "custom-alert-success",
                        styles:{fontSize:12, position:"absolute", top: 4}
                    }
                    break;
                case 3:
                    state1 = {
                        icon: "fa fa-check-square-o",
                        text: "Ya realizaste esta solicitud. Pendiente por Verificación de Pago",
                        class: "custom-alert-warning",
                        styles:{fontSize:12, position:"absolute", top: 4}
                    }
                    break;
                case 4:
                    state1 = {
                        icon: "fa fa-check-square-o",
                        text: "Ya realizaste esta solicitud. Pendiente por Verificación de Control de Estudios",
                        class: "custom-alert-warning",
                        styles:{fontSize:12, position:"absolute", top: 4}
                    }
                    break;
                case 6:
                    state1 = {
                        icon: "fa fa-times-circle",
                        text: "No puedes realizar este proceso porque no tienes Estado de Cuenta",
                        class: "custom-alert-danger",
                        styles:{fontSize:12, position:"absolute", top: 4}
                    }
                    break;
                default:
                    state1 = {
                        icon: "fa fa-times-circle",
                        text: "Para poder solicitar el cambio de carrera no debes estar inscrito",
                        class: "custom-alert-danger",
                        styles:{fontSize:12, position:"absolute", top: 4}
                    }
                    break;
            }

            let contenidoCarr =[]

            for (let i in carreras) {
                contenidoCarr.push({
                    value: carreras[i].id,
                    label: carreras[i].carrera_name,
                })
            }

            respuesta([datos, statusVar, state1, datHistoricos, carrera, contenidoCarr, carrCambio, prederencias])
        });
    });
}

export const SolicitarCambio = (carreraActual, carreraSolicitada, respuesta) => {
    consultaUser ((usuario) => {
        let Content = {
            id: usuario,
            carreraAct: carreraActual,
            carerraSol: carreraSolicitada
        }

        Post(`${Url}solCambioCarrera`, Content, (resp) => {
            respuesta(false)
        });

    });
}


// WEBPACK FOOTER //
// ./src/funciones/CambioCarrFunction.jsx